export default {
    processing: "Processing",
    packing: "It's packing",
    confirmed: "Confirmed",
    transit: "In transit",
    shipped: "Shipped",
    cancel: "Canceled"
};
